export const INCOMING = "incoming";
export const OUTGOING = "outgoing";
export const CHATGPT = "ChatGPT";
export const USER = "user";
